import { render, staticRenderFns } from "./EchartOrderData.vue?vue&type=template&id=004b5b1f&scoped=true&lang=pug&"
import script from "./EchartOrderData.vue?vue&type=script&lang=js&"
export * from "./EchartOrderData.vue?vue&type=script&lang=js&"
import style0 from "./EchartOrderData.vue?vue&type=style&index=0&id=004b5b1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b5b1f",
  null
  
)

export default component.exports